// Canonical mirror: functions/lib/notificationEligibility.js.
// Changes here must land in both files, with matching tests on both sides.
// The functions-side copy is consumed by functions/lib/notifications.js to
// decide who actually receives an SMS; this frontend copy is consumed by the
// admin Users tab to render "would receive / would NOT receive" badges. The
// two must agree or the badges lie.

/**
 * Returns true iff `user` would currently receive a notification of the given
 * preference type. Four conditions, all of which must hold:
 *   1. phoneVerified === true
 *   2. smsOptOut !== true   (missing/undefined treated as not opted out)
 *   3. smsPreferences[preferenceKey] === true
 *   4. phoneNumber present and non-empty
 *
 * @param {object|null|undefined} user
 * @param {'newGames' | 'kickoffReminder' | 'leaderboardUpdate'} preferenceKey
 * @returns {boolean}
 */
export function wouldReceive(user, preferenceKey) {
  if (!user) return false;
  return (
    user.phoneVerified === true &&
    user.smsOptOut !== true &&
    !!user.smsPreferences &&
    user.smsPreferences[preferenceKey] === true &&
    !!user.phoneNumber
  );
}
